import React, { createRef } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import SmartDataTable from "react-smart-data-table";
import {
  loadAllUsers,
  loadAllUsersForSearch,
  search,
  DownloadExcel,
} from "../../../actions/auth";
import { migrateQuestions } from "../../../actions/questions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import classes from "./table.module.css";
import Footer from "./Footer";
import { MY_PROFILE, SITE_URL } from "../../../actions/types";
import Loader from "../loader";
import Spinner from "../Spinner";
import "../../../assests/css/Styless.css";
import loader from "../loader";
import { patch } from "request";
import Pagination from "react-js-pagination";
import { data, event } from "jquery";
const moment = require("moment");

const sematicUI = {
  segment: "ui segment",
  message: "ui message",
  labeledInput: "ui right labeled input",
  iconInput: "ui icon input",
  searchIcon: "search icon",
  rowsIcon: "numbered list icon",
  table: "ui compact selectable table",
  select: "ui dropdown",
  refresh: "ui labeled primary icon button",
  refreshIcon: "sync alternate icon",
  change: "ui labeled secondary icon button",
  changeIcon: "exchange icon",
  checkbox: "ui toggle checkbox",
  loader: "ui active text loader",
  deleteIcon: "la la-trash",
  editIcon: "la la-edit",
  viewIcon: "la la-eye",
};

const apiDataUrls = ["/v2/questions"];

const generateData = (list = 0, numResults = 0) => {
  let total = numResults || 0;
  if (typeof numResults === "string") {
    total = parseInt(numResults, 10);
  }
  const data = [];
  for (let i = 0; i < total; i += 1) {
    var a = i;
    function concatenateRowData() {
      let parts = [];
      if (list[i]?.branch_data?.feature)
        parts.push(list[i]?.branch_data?.feature);
      if (list[i]?.branch_data?.source)
        parts.push(list[i]?.branch_data?.source);
      if (list[i]?.branch_data?.campaign)
        parts.push(list[i]?.branch_data?.campaign);
      if (list[i]?.branch_data?.tags) parts.push(list[i]?.branch_data?.tags);

      if (parts?.length === 0) {
        return "-";
      } else {
        console.log("Parts...", parts);
      }
      return parts?.join("_");
    }
    const dataRadar = list[i]?.radar
      ?.map((cityObj) => cityObj?.city)
      .filter(Boolean) // Optional: Filter out any undefined or null values
      .join(", "); // Join the array into a comma-separated string

    data.push({
      srNo: list[i]?.srNo ? list[i]?.srNo : ++a,
      _id: list[i]?._id,
      firstname: list[i]?.firstname,
      email: list[i]?.email,
      phone: list[i]?.phone,
      age: list[i]?.age,
      profile_image: list[i]?.profile_image,
      dob: list[i]?.dob,
      identity:
        list[i]?.identity === "Other"
          ? list[i]?.gender?.charAt(0).toUpperCase() + list[i]?.gender?.slice(1)
          : list[i]?.identity,

      interest_in: list[i]?.interest_in,
      radar: dataRadar ? dataRadar : "-",

      account_status: list[i]?.account_status,
      flag_raised: list[i]?.flag_raised,
      created_at: list[i]?.created_at,
      source: concatenateRowData(),
      Living: list[i]?.detailed_profile?.live_where?.liveCity,
      updated_at: list[i]?.updated_at,
      otp_verify: list[i]?.otp_verify,
      riskFactor: list[i]?.riskFactor,
      fraud_score: list[i]?.fraud_score,

      Profile_Status:
        list[i]?.detailed_profile?.about_me?.length == 0 ||
        list[i]?.detailed_profile?.height?.Feet == null ||
        list[i]?.detailed_profile?.height?.Inches == null ||
        list[i]?.detailed_profile?.work_and_education?.ethnicity == null || //---ethnicity
        list[i]?.detailed_profile?.work_and_education?.occupation?.length == //---occupation
          0 ||
        list[i]?.location?.coordinates?.length == 0 || //---coordinates
        list[i]?.detailed_profile?.basic_information?.identity?.length == 0 || //-----gender
        list[i]?.detailed_profile?.from_where?.fromCity?.length == 0 || // --from city
        list[i]?.detailed_profile?.live_where?.liveCity?.length == 0 || // --live city
        list[i]?.detailed_profile?.date_question?.[0]?.length == 0 || //---first date question
        list[i]?.detailed_profile?.date_question?.[1]?.length == 0 ||
        list[i]?.detailed_profile?.date_question?.[2]?.length == 0 ||
        //--My values
        list[i]?.detailed_profile?.drinking == null ||
        list[i]?.detailed_profile?.drugs == null ||
        list[i]?.detailed_profile?.family_plans == null ||
        list[i]?.detailed_profile?.fitness == null ||
        list[i]?.detailed_profile?.looking_for == null ||
        list[i]?.detailed_profile?.marijuana == null ||
        list[i]?.detailed_profile?.pets == null ||
        list[i]?.detailed_profile?.political_views == null ||
        list[i]?.detailed_profile?.religion == null ||
        list[i]?.detailed_profile?.smoking == null
          ? "Incomplete"
          : "complete",
    });
  }

  return data;
};

class AppDemo extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = createRef();
    this.state = {
      default_page: "10 ",
      itemsPerPage: 10,
      activePage: 1,
      filterData: "",
      loadingData: false,
      listReducer: [],
      list: [],
      useApi: true,
      apiData: "/v2/questions",
      apiIdx: -1,
      numResults: 100,
      data: [],
      filterValue: "",
      perPage: 0,
      page: 0,
      pageNo: 1,
      totalEntries: 0,
      creditsData: {},
      showOnRowClick: true,
      changeOrder: false,
      list: [],
      message: "",
      check: [],
      checkLength: 0,
      previousRow: "",
      deleteAbleArray: [],
      partialStatus: "",
      categoriesArray: [],
      subcategory: [],
      subcategoryErr: "",
      category_name: "",
      passwordType: "password",
      password: "",
      showPopup: false,
      account_id: "",
      passwordError: "",
      alertClass: "",
      account_id_error: "",
      deleteUserId: "",
      password_updated: "",
      migrate_id: "",
      filterData: [],
      selectedAccounts: [],
      selectedAccountsName: [],
      creditsAmount: "",
      searchValue: "",
      searchResults: false,
      searchPage: 1,
      sortBy: 1,
      noRecordFound: false,
      noDataFound: false,
      activePage: 1,
      itemsPerPage: 10,
      total: 0,
      loaders: localStorage.getItem("loader"),
      orderedHeaders: [
        "_id",
        "srNo",
        "profile_image",
        "firstname",
        "email",
        "phone",
        "dob",
        "age",
        "identity",
        "interest_in",
        "radar",
        "account_status",
        "source",
        "Living",
        "updated_at",
        "Profile_Status",
        "riskFactor",
        "fraud_score",
        "otp_verify",
        "created_at",
        "flag_raised",
      ],
      hideUnordered: false,
    };

    this.setNewData = this.setNewData.bind(this);
    this.setApiData = this.setApiData.bind(this);
    this.changeData = this.changeData.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnPerPage = this.handleOnPerPage.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.handleOnChangeOrder = this.handleOnChangeOrder.bind(this);
    this.ExportExcel = this.ExportExcel.bind(this);
  }

  handlePageChange = (pagenumber) => {
    debugger;
    if (pagenumber) {
      this.setState({ activePage: pagenumber });
      this.onChangePage(pagenumber);
    } else if (this.state.searchValue) {
      this.setState({ activePage: 1 });
    } else {
      localStorage.setItem("loader", false);
      this.setState({ loaders: false });
    }
  };

  componentDidMount() {
    // Wait until the page is fully loaded
    window.addEventListener("load", function () {
      // Select all the span elements with the desired classes
      const spans = document.querySelectorAll(
        ".rsdt.rsdt-column-toggles.toggle"
      );

      // Loop through the selected span elements and add a new class
      spans.forEach(function (span) {
        span.classList.add("your-new-class"); // Replace 'your-new-class' with the class you want to add
      });
    });
    const spanElement = document.querySelector(".rsdt.rsdt-column-toggles");
    if (spanElement) {
      spanElement.classList.add("new-class");
    }

    setTimeout(() => {
      const table = document.querySelector("table.selectable");
      if (table) {
        const headers = table.querySelectorAll("th");
        const headerTexts = Array.from(headers).map((header) =>
          header.textContent.trim()
        );
        console.log(
          headerTexts.length === 1 ? "No records" : "Headers found",
          "headerTexts..."
        );
      } else {
        console.log("Table not found");
      }
    }, 100);
    if (this.state.searchValue) {
      const { list, numResults, searchPage } = this.state;
      localStorage.setItem("loader", true);
      this.setState({ loaders: true, noRecordFound: false });

      this.setApiData();
      this.props
        .search(
          this.state.searchValue,
          searchPage,
          this.state.default_page,
          this.state.sortBy ? this.state.sortBy : "1"
        )
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.setState({
              list: res.data,
              numResults: res.data.length,
              page: res.total,
              searchResults: true,
              totalEntries: res.total,
              noRecordFound: false,
            });
            this.setNewData(res.data, res.data.length);
          } else {
            this.setState({
              noRecordFound: true,
              list: [],
              noDataFound: true,
              data: [],
            });
          }
          localStorage.setItem("loader", false);
          this.setState({ loaders: false });
        })
        .catch((err) => {
          console.error(err);
          localStorage.setItem("loader", false);
          this.setState({ loaders: false, noRecordFound: true, list: [] });
        });
    } else if (this.state.filterData && this.state.searchValue) {
      const { list, numResults, sortBy } = this.state;

      this.setState({
        default_page: this.state.default_page,
        // itemsPerPage: this.state.default_page ? this.state.default_page : 10,
        activePage: 1,
        filterData: "",
        loadingData: true, // Start loading
      });

      this.setState({ loaders: false });
      // const { list, numResults, sortBy } = this.state;
      this.setApiData();
      this.props
        .loadAllUsers(
          1,
          sortBy,
          this.state.default_page ? this.state.default_page : 10,
          this.state.searchValue ? this.state.searchValue : ""
        )
        .then((res) => {
          if (res) {
            this.setState({
              list: res.data,
              page: res.ttal,
              numResults: res.data.length,
              filterData: generateData(res, res.length, 1),
              totalEntries: res.total,
              searchResults: false,
              noRecordFound: false,
            });
            this.setNewData(list, numResults);
            this.addheadertbl();
          } else {
            this.setState({ noRecordFound: true });
          }
        })
        .catch((err) => {
          console.error(err, "ERRRRRRRR");
          this.setState({ noRecordFound: true });
        });
    } else {
      this.setState({ loaders: false });
      const { list, numResults, sortBy } = this.state;
      this.setApiData();
      this.props
        .loadAllUsers(
          1,
          sortBy,
          this.state.default_page ? this.state.default_page : 10
        )
        .then((res) => {
          if (res) {
            this.setState({
              list: res.data,
              page: res.ttal,
              numResults: res.data.length,
              filterData: generateData(res, res.length, 1),
              totalEntries: res.total,
              searchResults: false,
              noRecordFound: false,
            });
            this.setNewData(list, numResults);
            this.addheadertbl();
          } else {
            this.setState({ noRecordFound: true });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ noRecordFound: true });
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Scroll to top when data changes (e.g., filter or page change)
    if (
      prevState.filterValue !== this.state.filterValue ||
      prevState.data !== this.state.data
    ) {
      this.scrollToTop();
    }
    const table = document.querySelector("table.selectable");
    if (table) {
      const headers = table.querySelectorAll("th");

      // Loop through and log each header text
      headers.forEach((header) => {
        console.log(header.textContent.trim());
      });

      const headerTexts = Array.from(headers).map((header) =>
        header.textContent.trim()
      );

      console.log(
        headerTexts.length == 1 ? "no records" : "hyy",
        "headerTextsUSEFFECT..."
      );
    }
  }

  scrollToTop = () => {
    if (this.tableRef.current) {
      this.tableRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  sortData(sort) {
    const { list, numResults } = this.state;
    this.setApiData();
    localStorage.setItem("loader", true);
    this.setState({ loaders: true, activePage: 1 });
    this.props
      .loadAllUsers(1, sort, this.state.default_page)
      .then((res) => {
        if (res) {
          this.setState({
            list: res.data,
            page: res.total,
            numResults: res.data.length,
            filterData: generateData(res, res.length, 1),
            totalEntries: res.total,
            searchResults: false,
            sortBy: sort,
            noRecordFound: false,
          });
          this.setNewData(list, numResults);
        } else {
          this.setState({ noRecordFound: true });
        }
        localStorage.setItem("loader", false);
        this.setState({ loaders: false });
      })
      .catch((err) => {
        console.error(err);
        localStorage.setItem("loader", false);
        this.setState({ loaders: false });
      });
  }
  // onChangePage(e) {
  //   var page = e;
  //   const { list, numResults, sortBy } = this.state;
  //   this.setState({ pageNo: page });

  //   localStorage.setItem("loader", true);
  //   this.setState({ loaders: true });

  //   this.state.searchResults == false
  //     ? this.props
  //         .loadAllUsers(page, sortBy)
  //         .then((res) => {
  //           if (res) {
  //             this.setState({
  //               list: res.data,
  //               numResults: res.data.length,
  //               page: res.total,
  //             });
  //             this.setNewData(list, numResults);
  //           }
  //         })
  //         .catch((err) => {
  //           console.error(err);
  //         })
  //         .finally(() => {
  //           localStorage.setItem("loader", false);
  //           this.setState({ loaders: false });
  //         })
  //     : this.props.search(this.state.searchValue, page).then((res) => {
  //         localStorage.setItem("loader", false);

  //         this.setState({ loaders: false });
  //         this.setState({
  //           list: res.data,
  //           numResults: res.data.length,
  //           page: res.total,
  //           page: res.total,
  //           searchResults: true,
  //         });
  //         this.setNewData(list, numResults);
  //         //this.componentDidMount();

  //         // this.setState({
  //         //   list: res,
  //         //   filterData: generateData(res, res.length),
  //         // });
  //
  //       });
  // }
  onChangePage(page) {
    const { sortBy, default_page, searchResults, searchValue } = this.state;
    this.setState({ pageNo: page, loaders: true }, () => {
      if (!searchResults) {
        this.props
          .loadAllUsers(
            page,
            sortBy,
            this.state.default_page ? this.state.default_page : 10
            // this.state.sortBy ? this.state.sortBy : 1
          )
          .then((res) => {
            const totalPages = Math.ceil(res.total / (default_page || 10));

            if (res) {
              this.setState({
                list: res.data,
                numResults: res.data.length,
                page: totalPages,
              });
              this.setNewData(this.state.list, this.state.numResults);
            }
          })
          .catch((err) => console.error(err))
          .finally(() => {
            this.setState({ loaders: false });
            localStorage.setItem("loader", false);
          });
      } else {
        this.props
          .search(
            searchValue,
            page,
            this.state.default_page ? this.state.default_page : 10,
            this.state.sortBy ? this.state.sortBy : "1"
          )
          .then((res) => {
            const totalPages = Math.ceil(res.total / (default_page || 10));
            this.setState({
              list: res.data,
              numResults: res.data.length,
              page: totalPages,
              searchResults: true,
            });
            this.setNewData(this.state?.list, this.state?.numResults);
          })
          .catch((err) => console.error(err, "errerrerrerr"))
          .finally(() => {
            this.setState({ loaders: false });
            localStorage.setItem("loader", false);
          });
      }
    });
  }

  onChangeMode = (e) => {
    this.props.sleepQuestion(e.target.value).then((res) => {
      //window.location = window.location;
      this.componentDidMount();
      this.componentDidMount();
    });
  };

  addheadertbl() {
    if (
      !document.getElementById("scroll-left") &&
      !document.getElementById("scroll-right")
    ) {
      const existingElement = document.querySelector(".user-table-main");
      existingElement.insertAdjacentHTML(
        "beforebegin",
        '<div class="scroll-buttons">' +
          '<a class="new-element" id="scroll-left"><i class="fa fa-chevron-circle-left fa-lg" aria-hidden="true"></i></a>' +
          '<a class="new-element2" id="scroll-right"><i class="fa fa-chevron-circle-right fa-lg" aria-hidden="true"></i></a>' +
          "</div>"
      );
    }
    const table = document.querySelector("table.selectable");
    const headers = table.querySelectorAll("th");
    // Loop through and log each header text
    headers.forEach((header) => {
      console.log(header.textContent.trim());
    });
    const headerTexts = Array.from(headers).map((header) =>
      header.textContent.trim()
    );
    console.log(
      headerTexts.length == 1 ? "no records" : "hyy",
      "headerTexts..."
    );
    // Get the scroll buttons
    const scrollRightButton = document.getElementById("scroll-right");
    const scrollLeftButton = document.getElementById("scroll-left");

    // Function to update the state of the scroll buttons (color)
    const updateScrollButtonsState = () => {
      const tableContainer = document.querySelector(".user-table-main");
      const maxScrollLeft =
        tableContainer.scrollWidth - tableContainer.clientWidth;

      // Check if scrolled all the way left
      if (tableContainer.scrollLeft === 0) {
        scrollLeftButton.style.color = "gray"; // Gray out the left button
      } else {
        scrollLeftButton.style.color = "#4b70dc"; // Make the left button blue
      }

      // Check if scrolled all the way right
      if (tableContainer.scrollLeft >= maxScrollLeft) {
        scrollRightButton.style.color = "gray"; // Gray out the right button
      } else {
        scrollRightButton.style.color = "#4b70dc"; // Make the right button blue
      }
    };

    // Initial check of the button states
    updateScrollButtonsState();

    if (scrollRightButton) {
      scrollRightButton.onclick = function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Get the table container
        const tableContainer = document.querySelector(".user-table-main");

        // Scroll to the right by a set amount
        const scrollAmount = 600;
        const currentScrollPosition = tableContainer.scrollLeft;

        // Scroll to the right
        tableContainer.scrollTo({
          left: currentScrollPosition + scrollAmount,
          behavior: "smooth",
        });

        // Update button state after scrolling
        setTimeout(updateScrollButtonsState, 300);
      };
    }

    if (scrollLeftButton) {
      scrollLeftButton.onclick = function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Get the table container
        const tableContainer = document.querySelector(".user-table-main");

        // Scroll to the left by a set amount
        const scrollAmount = 600;
        const currentScrollPosition = tableContainer.scrollLeft;

        // Scroll to the left
        tableContainer.scrollTo({
          left: Math.max(currentScrollPosition - scrollAmount, 0),
          behavior: "smooth",
        });

        // Update button state after scrolling
        setTimeout(updateScrollButtonsState, 300);
      };
    }

    const tableContainer = document.querySelector(".user-table-main");
    tableContainer.addEventListener("scroll", updateScrollButtonsState);
  }

  // original old code
  filter2(e) {
    const { searchValue, sortBy, searchPage } = this.state;
    const selectedValue = e.target.value;
    if (searchValue && e.target.value) {
      this.setState(
        {
          default_page: e.target.value,
          itemsPerPage: e.target.value,
          activePage: 1,
          filterData: "",
          loadingData: true, // Start loading
        },
        () => {
          this.setApiData();
          this.props
            .search(
              this.state.searchValue,
              searchPage,
              this.state.default_page ? this.state.default_page : 10,
              this.state.sortBy ? this.state.sortBy : "1"
            )
            .then((res) => {
              if (res && res.data && res.data.length > 0) {
                this.setState({
                  list: res.data,
                  numResults: res.data.length,
                  page: res.total,
                  searchResults: true,
                  totalEntries: res.total,
                  noRecordFound: false,
                });
                this.setNewData(res.data, res.data.length);
              } else {
                this.setState({
                  noRecordFound: true,
                  list: [],
                  noDataFound: true,
                  data: [],
                });
              }
              localStorage.setItem("loader", false);
              this.setState({ loaders: false });
            })
            .catch((err) => {
              console.error(err);
              this.setState({ noRecordFound: true });
            });
        }
      );
      this.setState({ loaders: false });

      // localStorage.setItem("loader", true);

      // this.setState(
      //   {
      //     loaders: true,
      //     noRecordFound: false,
      //     default_page: e.target.value,
      //     itemsPerPage: e.target.value,
      //   },
      //   () => {
      //     console.log(sortBy, "this.state.sortBy after state update");

      //     // Ensure that this.setApiData() runs after state update
      //     this.setApiData();

      //     // Now that state is updated, run the search
      //     this.props
      //       .search(
      //         searchValue,
      //         searchPage,
      //         e.target.value,
      //         sortBy ? sortBy : "1"
      //       )
      //       .then((res) => {
      //         if (res && res.data && res.data.length > 0) {
      //           this.setState({
      //             list: res.data,
      //             numResults: res.data.length,
      //             page: res.total,
      //             filterData: generateData(res, res.length, 1),
      //             searchResults: true,
      //             totalEntries: res.total,
      //             noRecordFound: false,
      //           });
      //           this.setNewData(res.data, res.data.length);
      //         } else {
      //           this.setState({
      //             noRecordFound: true,
      //             list: [],
      //             noDataFound: true,
      //             data: [],
      //           });
      //         }
      //         localStorage.setItem("loader", false);
      //         this.setState({ loaders: false });
      //       })
      //       .catch((err) => {
      //         console.error(err);
      //         localStorage.setItem("loader", false);
      //         this.setState({ loaders: false, noRecordFound: true, list: [] });
      //       });
      //   }
      // );
    } else if (e.target.value) {
      this.setState(
        {
          default_page: selectedValue,
          itemsPerPage: selectedValue,
          activePage: 1,
          filterData: "",
          loadingData: true, // Start loading
        },
        () => {
          this.setApiData();

          this.props
            .loadAllUsers(1, sortBy, selectedValue ? selectedValue : 10)
            .then((res) => {
              if (res) {
                this.setState({
                  list: res.data,
                  page: res.total,
                  numResults: res.data.length,
                  filterData: generateData(res, res.length, 1),
                  totalEntries: res.total,
                  searchResults: false,
                  noRecordFound: false,
                });
                this.setNewData(res.data, res.data.length);
                this.addheadertbl();
              } else {
                this.setState({ noRecordFound: true });
              }
            })
            .catch((err) => {
              console.error(err);
              this.setState({ noRecordFound: true });
            });
        }
      );

      this.setState({ loaders: false });
    }
  }

  setNewData() {
    const { list, numResults } = this.state;
    this.setState({
      data: generateData(list, numResults),
    });
  }

  searchResult() {
    if (this.state.searchValue == "") {
      localStorage.setItem("loader", true);
      this.setState({ loaders: true }, () => {
        this.componentDidMount();
        this.setState({ loaders: false }); // Ensure loader is stopped after the data is fetched
        localStorage.setItem("loader", false);
      });
      // this.componentDidMount();
    } else {
      const { list, numResults, searchPage } = this.state;
      localStorage.setItem("loader", true);
      this.setState({ loaders: true, noRecordFound: false, activePage: 1 });

      this.setApiData();
      this.props
        .search(
          this.state.searchValue,
          searchPage,
          this.state.default_page ? this.state.default_page : 10,
          this.state.sortBy ? this.state.sortBy : "1"
        )
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.setState({
              list: res.data,
              numResults: res.data.length,
              page: res.total,
              searchResults: true,
              totalEntries: res.total,
              noRecordFound: false,
            });
            this.setNewData(res.data, res.data.length);
          } else {
            this.setState({
              noRecordFound: true,
              list: [],
              noDataFound: true,
              data: [],
            });
          }
          localStorage.setItem("loader", false);
          this.setState({ loaders: false });
        })
        .catch((err) => {
          console.error(err);
          localStorage.setItem("loader", false);
          this.setState({ loaders: false, noRecordFound: true, list: [] });
        });
    }
  }

  accountStatus = ["Active", "Deleted", "Suspended", "Paused"];
  setApiData() {
    let { apiIdx } = this.state;
    const N = apiDataUrls.length;
    apiIdx += 1;
    if (apiIdx === N) apiIdx -= N;
    const apiData = apiDataUrls[apiIdx];
    this.setState({ apiData, apiIdx });
  }

  sendData() {
    const table = document.querySelector("table.selectable");
    if (table) {
      // Get all <th> elements within the table
      const headers = table.querySelectorAll("th");
      // Loop through and log each header text
      headers.forEach((header) => {
        console.log(header.textContent.trim());
      });
      const headerTexts = Array.from(headers).map((header) =>
        header.textContent.trim()
      );
      console.log(headerTexts, "headerTexts...");
    } else {
      console.log('Table with class "selectable" not found.');
    }
  }

  async ExportExcel() {
    const table = document.querySelector("table.selectable");

    if (table) {
      const headers = table.querySelectorAll("th");
      const excludedHeaders = ["Match & Chat Details", "Flag", "Profile"];

      const headerTexts = Array.from(headers)
        .map((header) => header.textContent.trim())
        .filter((header) => !excludedHeaders.includes(header));
      try {
        localStorage.setItem("loader", true);
        this.setState({ loaders: true });

        await this.props.DownloadExcel(headerTexts, true);
      } catch (error) {
        localStorage.setItem("loader", false);
        this.setState({ loaders: false });
      } finally {
        localStorage.setItem("loader", false);
        this.setState({ loaders: false });
      }
    } else {
      console.log('Table with class "selectable" not found.');
    }
  }

  getHeaders() {
    return {
      srNo: {
        text: "No.",
        invisible: false,
        filterable: false,
        transform: (event, idx, row) => {
          return (
            <div
              className="srno"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
                maxWidth: "40px",
                minWidth: "40px",
                width: "40px",
              }}
            >
              {row.srNo}
            </div>
          );
        },
      },
      _id: {
        text: "Identifier",
        invisible: true,
        filterable: false,
        transform: (value) => {
          return (
            <div
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 8,
              }}
            >
              {value}
            </div>
          );
        },
      },
      profile_image: {
        text: "Profile",
        sortable: true,
        filterable: false,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{ textAlign: "left", alignItems: "flex-start" }}
            >
              <Link to={`view-user-detail/${row?._id}`}>
                <img
                  src={
                    row?.profile_image
                      ? MY_PROFILE + "/" + row?.profile_image
                      : "img/noImage.png"
                  }
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                    e.target.src = "img/noImage.png"; // Fallback image if loading fails
                  }}
                  style={{
                    height: "65px",
                    borderRadius: "50px",
                    width: "65px",
                  }}
                />
              </Link>
            </div>
          );
        },
      },

      firstname: {
        text: "Name",
        invisible: false,
        sortable: true,
        filterable: false,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              <Link to={`view-user-detail/${row?._id}`}>
                {row?.firstname ? row?.firstname : "-"}
              </Link>
            </div>
          );
        },
      },
      email: {
        text: "Email",
        sortable: true,
        filterable: false,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row.email ? row.email : "-"}
            </div>
          );
        },
      },
      phone: {
        text: "Phone",
        sortable: true,
        filterable: false,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.phone ? row?.phone : "-"}
            </div>
          );
        },
      },
      dob: {
        text: "Date of Birth",
        sortable: true,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "center",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.dob ? row?.dob : "-"}
            </div>
          );
        },
      },
      age: {
        text: "Age",
        sortable: true,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row.age == 0 || row.age == null || row.age == ""
                ? "-"
                : row?.age}
            </div>
          );
        },
      },
      identity: {
        text: "Gender",
        sortable: true,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row.identity == "" ||
              row.identity == 0 ||
              row.identity == null ||
              row.identity == "null"
                ? "-"
                : row.identity}
            </div>
          );
        },
      },
      interest_in: {
        text: "Interested In",
        sortable: true,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row.interest_in == "Select" ||
              row.interest_in == "" ||
              row.interest_in == null ||
              row.interest_in == "null" ||
              row.interest_in == undefined
                ? "-"
                : row.interest_in}
            </div>
          );
        },
      },

      radar: {
        text: "Radar",
        sortable: true,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.radar ? row?.radar : "-"}
            </div>
          );
        },
      },

      account_status: {
        text: "Status",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {this.accountStatus[row.account_status]}
            </div>
          );
        },
      },

      source: {
        text: "Source",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                // width: "max-content",
                textAlign: "center",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
                alignSelf: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {row.source ? row.source : "-"}
            </div>
          );
        },
      },

      Living: {
        text: "Location",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                // width: "max-content",
                textAlign: "center",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
                alignSelf: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {row.Living ? row.Living : "-"}
            </div>
          );
        },
      },

      updated_at: {
        text: "Last Login",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {moment(row?.updated_at ? row?.updated_at : "-").format(
                "MM-DD-YYYY"
              )}
            </div>
          );
        },
      },

      Profile_Status: {
        text: "Profile Status",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.Profile_Status ? row?.Profile_Status : "-"}
            </div>
          );
        },
      },

      fraud_score: {
        text: "IDMtrust",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {/* {row?.fraud_score > 70  ? "Non eligible" : "Eligible"} */}
              {row?.fraud_score > 70
                ? "Non eligible"
                : row?.fraud_score === "" ||
                  row?.fraud_score === "null" ||
                  row?.fraud_score === null ||
                  row?.fraud_score === -1
                ? "Not checked yet"
                : "Eligible"}
            </div>
          );
        },
      },

      riskFactor: {
        text: "IDMerit",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.riskFactor > 75
                ? "Not verified"
                : row?.riskFactor == -1 ||
                  row?.riskFactor == "" ||
                  row?.riskFactor == null
                ? "Not checked yet"
                : "verified"}
            </div>
          );
        },
      },

      otp_verify: {
        text: "OTP Verified",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row?.otp_verify == 1
                ? "Verified "
                : row.otp_verify == 0
                ? "Not verified "
                : ""}
            </div>
          );
        },
      },

      created_at: {
        text: "Registration Date",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {moment(row.created_at).format("MM-DD-YYYY")}
              {/* {row.created_at.split("T")[0]} */}
            </div>
          );
        },
      },
      flag_raised: {
        text: "Flag",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              {row.flag_raised == 1 ? (
                <i className="fas fa-flag" style={{ color: "red" }} />
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      match: {
        text: "Match & Chat Details",
        sortable: false,
        filterable: true,
        transform: (event, idx, row) => {
          return (
            // <div>
            <div
              className="tooltxt password-parent"
              style={{
                width: "max-content",
                textAlign: "left",
                fontSize: 14,
                color: "#000000",
                marginLeft: 10,
              }}
            >
              <a href={`single-match-list/${row._id}`}>
                <button className="btn btn-primary">Open Details</button>
              </a>
            </div>
            //   <div
            //   className="tooltxt password-parent"
            //   style={{
            //     width: "max-content",
            //     textAlign: "left",
            //     fontSize: 14,
            //     color: "#000000",
            //     marginLeft: 10,
            //     marginTop:7
            //   }}
            // >
            //   <Link to={`view-user-detail/${row._id}`}>View Profile</Link>
            //   {/* <a href={`view-user-detail/${row._id}`}>
            //     <button className="btn btn-primary">View Profile</button>
            //   </a> */}
            // </div>
            // </div>
          );
        },
      },
    };
  }

  handleOnChange({ target: { name, value } }) {
    this.setState({ [name]: value }, () => {
      if (name === "numResults") this.setNewData();
    });
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ searchValue: e.target.value });
      this.searchResult();
    }
  };

  handleOnChangeOrder(now, next) {
    const { orderedHeaders } = this.state;
    const N = orderedHeaders.length;
    let nextPos = next;
    if (next < 0) {
      nextPos = N;
    }
    if (next >= N) {
      nextPos = 0;
    }
    const newOrderedHeaders = [...orderedHeaders];
    const mvElement = newOrderedHeaders.splice(now, 1)[0];
    newOrderedHeaders.splice(nextPos, 0, mvElement);
    this.setState({ orderedHeaders: newOrderedHeaders });
  }

  handleOnPerPage({ target: { name, value } }) {
    this.setState({ [name]: parseInt(value, 10) });
  }

  changeData() {
    const { useApi } = this.state;
    this.setState({
      useApi: !useApi,
      filterValue: "",
      perPage: 0,
    });
  }
  getUsers = [];
  getUsersName = [];

  onClickSelectButton(row) {
    var id = row._id;
    var name = row.name;

    var index = this.getUsers.indexOf(id);
    var nameIndex = this.getUsersName.indexOf(name);
    if (index == -1) {
      this.getUsers.push(id);
      //setNewCompare(false);
    } else if (index > -1) {
      this.getUsers.splice(index, 1);
    }
    if (nameIndex == -1) {
      this.getUsersName.push(name);
      //setNewCompare(false);
    } else if (nameIndex > -1) {
      this.getUsersName.splice(nameIndex, 1);
    }
    this.setState({
      selectedAccounts: this.getUsers,
      selectedAccountsName: this.getUsersName,
    });
  }
  handleCheckboxChange({ target: { name, checked } }) {
    this.setState({ [name]: checked });
  }
  deleteAbleArrayHere = [];

  onRowClick(event, { rowData, rowIndex, tableData }) {
    const { showOnRowClick, previousRow } = this.state;
    this.setState({ message: "" });

    if (previousRow == "") {
      this.setState({ previousRow: rowIndex });
    }
    if (previousRow != "" && !event.shiftKey) {
      this.setState({ previousRow: "" });
      this.setState({ deleteAbleArray: [] });
      this.deleteAbleArrayHere = [];
    }

    if (event.shiftKey) {
      for (var i = 0; i < tableData.length; i++) {
        if (i >= previousRow && i <= rowIndex) {
          var index = this.deleteAbleArrayHere.indexOf(tableData[i]._id);
          if (index == -1) {
            this.deleteAbleArrayHere.push(tableData[i]._id);
            //setNewCompare(false);
          }
        }
      }
      this.setState({ deleteAbleArray: this.deleteAbleArrayHere });
    }
  }

  render() {
    const {
      useApi,
      apiData,
      data,
      filterValue,
      perPage,
      numResults,
      showOnRowClick,
      changeOrder,
      orderedHeaders,
      hideUnordered,
      totalEntries,
      list,
      pageNo,
      activePage,
      itemsPerPage,

      total,
      noRecordFound,
    } = this.state;

    const divider = (
      <span style={{ display: "inline-block", margin: "10px" }} />
    );
    const headers = this.getHeaders();

    const rowClick = this.state.deleteAbleArray;
    const pageArray = list.map((comment, index) => {
      return index == 0 ? comment.showPagination : [];
    });
    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n.rsdt input[type=checkbox], input[type=radio] {\n    box-sizing: border-box;\n    padding: 0px;\n    margin: 10px;\n}\n.rsdt label {\n    display: inline-block;\n    margin-bottom: .5rem;\n  color:black;\n   padding: 7px;\n}\n",
          }}
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\ntable.table.table-responsive {\n    text-align: center;\n    display: inline-table !important;\n}\n",
          }}
        />
        {/* Page Wrapper */}
        <div id="wrapper">
          {/* Sidebar */}
          <Sidebar />
          {/* End of Sidebar */}
          {/* Content Wrapper */}
          <div id="content-wrapper" className="d-flex flex-column">
            {/* Main Content */}
            <div id="content">
              <Header />
              <div className="container-fluid new-tabel">
                <div className="card user-card shadow mb-4">
                  <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Users</h6>
                  </div>
                  <div className="card-body">
                    <div>
                      <div
                        className={classes.table_style}
                        style={{ paddingLeft: 10, paddingRight: 10 }}
                      >
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              "\ntable.table.table-responsive {\n    text-align: center;\n    display: list-item !important;\n}\n",
                          }}
                        />
                        <div className="row mb-2">
                          <div className="col-md-8">
                            <input
                              type="text"
                              placeholder="Enter name, email, or phone number to search"
                              id="search"
                              onChange={(e) =>
                                this.setState({ searchValue: e.target.value })
                              }
                              className="form-control"
                              onKeyDown={this.handleKeyDown}
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              className="btn btn-primary form-control"
                              onClick={() => this.searchResult()}
                            >
                              Search
                            </button>
                          </div>
                          <div className="col-md-2">
                            <button
                              className="btn btn-primary form-control"
                              onClick={() => this.ExportExcel()}
                              // disabled={this.state.loaders}
                            >
                              Export
                            </button>
                          </div>
                          <div className="col-md-6 mt-3">
                            <select
                              className="form-select w50"
                              id="inlineFormSelectPref"
                              value={this.state.default_page}
                              onChange={(e) => this.filter2(e)}
                            >
                              <option value={"10 "}>Select No of Rows</option>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </div>
                          {this.state.loaders && (
                            <div class="overlay">
                              <div className="loader">
                                <Spinner />
                              </div>
                            </div>
                          )}{" "}
                          <div className="col-md-6 mt-3">
                            <select
                              className="form-select w100"
                              onChange={(e) => this.sortData(e.target.value)}
                              style={{ cursor: "pointer" }}
                            >
                              <option value="1">Sort by Most Recent</option>
                              <option value="2">Sort by Most Previous</option>
                              <option value="3">Sort by Status</option>
                              <option value="4">Sort by Name</option>
                              <option value="5">Sort by Email</option>
                              <option value="6">Sort by Flag</option>
                            </select>
                          </div>
                        </div>{" "}
                        <SmartDataTable
                          //data='/v2/questions'
                          data={
                            filterValue !== "" ? this.state.filterData : data
                          }
                          dataKey=""
                          headers={headers}
                          orderedHeaders={orderedHeaders}
                          hideUnordered={hideUnordered}
                          name="users"
                          className={`${sematicUI.table} table user-table-main table-responsive`}
                          filterValue={filterValue}
                          // perPage={perPage}
                          // sortable
                          withToggles
                          withLinks
                          withHeader
                          loader={<Loader />}
                          parseImg={{
                            style: {
                              border: "1px solid #ddd",
                              borderRadius: "2px",
                              padding: "3px",
                              width: "60px",
                            },
                          }}
                          dynamic
                          emptyTable={
                            this.state.data.length > 0 ? (
                              <div
                                className="noRecordFoundUserTable"
                                style={{
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Spinner />
                                <div className="loader-container">
                                  <div className="loaderss"></div>
                                </div>
                              </div>
                            ) : this.state.noDataFound ? (
                              <h5 className="text-center mt-5">
                                No Records Found
                              </h5>
                            ) : (
                              <div className="loader-container">
                                <div className="loaderss"></div>
                              </div>
                            )
                          }
                        />
                        <div className="d-flex justify-content-between">
                          <div className="my-records-number">
                            {data.length > 0
                              ? data.map((c, i) =>
                                  i == 0 ? (
                                    <p>
                                      Showing {c.srNo} to{" "}
                                      {Number(c.srNo) +
                                        (Number(data.length) - 1)}{" "}
                                      of {totalEntries} entries
                                    </p>
                                  ) : (
                                    ""
                                  )
                                )
                              : ""}
                          </div>
                          {/* <div className="my-records-number px-4">
                            <div className="dataTables_paginate_custom">
                              {totalEntries != 0 && (
                                <ul
                                  data-test="pagination"
                                  className="pagination"
                                >
                                  {list.length > 0
                                    ? list.map((c, i) =>
                                        i == 0 ? (
                                          <>
                                            <li
                                              data-test="page-item"
                                              // onClick={(event) =>
                                              //   this.onChangePage(1)
                                              // }
                                              onClick={
                                                pageNo > 1
                                                  ? () => this.onChangePage(1)
                                                  : null
                                              }
                                              className={`page-item ${
                                                pageNo <= 1 ? "disabled" : ""
                                              }`}
                                            >
                                              <a
                                                data-test="page-link"
                                                className="page-link page-link"
                                              >{`<<`}</a>
                                            </li>
                                            {console.log(
                                              "pageNo",
                                              Number(pageNo) - Number(1)
                                            )}
                                            <li
                                              data-test="page-item"
                                              // ahi thi baki che
                                              onClick={(event) =>
                                                this.onChangePage(
                                                  pageNo < c.totalPages &&
                                                    pageNo > 1
                                                    ? Number(pageNo) - Number(1)
                                                    : pageNo
                                                )
                                              }
                                              className={`page-item ${
                                                pageNo <= 1 ? "disabled" : ""
                                              }`}
                                            >
                                              <a
                                                data-test="page-link"
                                                className="page-link page-link"
                                              >{`<`}</a>
                                            </li>
                                          </>
                                        ) : (
                                          ""
                                        )
                                      )
                                    : ""}

                                  {pageArray.length > 0
                                    ? pageArray[0].map((page, i) => (
                                        <li
                                          data-test="page-item"
                                          onClick={() =>
                                            this.onChangePage(page)
                                          }
                                          key={i}
                                          className={
                                            pageNo == page
                                              ? "active page-item"
                                              : "page-item"
                                          }
                                        >
                                          <a
                                            data-test="page-link"
                                            className="page-link page-link"
                                          >
                                            {page}
                                            <span className="sr-only">
                                              (current)
                                            </span>
                                          </a>
                                        </li>
                                      ))
                                    : ""}
                                  {list.length > 0
                                    ? list.map((c, i) =>
                                        //console.log(c),
                                        i == 0 ? (
                                          <>
                                            <li
                                              data-test="page-item"
                                              onClick={(event) =>
                                                this.onChangePage(
                                                  pageNo < c.totalPages
                                                    ? Number(pageNo) + Number(1)
                                                    : pageNo
                                                )
                                              }
                                              className={"page-item"}
                                              
                                            >
                                              <a
                                                data-test="page-link"
                                              className="page-link page-link"
                                             
                                              >{`>`}</a>
                                            </li>
                                            <li
                                              data-test="page-item"
                                              onClick={(event) =>
                                                this.onChangePage(c.totalPages)
                                              }
                                              className={"page-item"}
                                            >
                                              <a
                                              data-test="page-link"
                                              
                                                className="page-link page-link"
                                              >{`>>`}</a>
                                            </li>
                                          </>
                                        ) : (
                                          ""
                                        )
                                      )
                                    : ""}
                                </ul>
                              )}
                            </div>
                          </div> */}

                          {list.length > 0 && totalEntries != 0 && (
                            <Pagination
                              activePage={activePage}
                              itemsCountPerPage={itemsPerPage}
                              totalItemsCount={totalEntries}
                              pageRangeDisplayed={5}
                              // onChange={()=>this.handlePageChange}
                              // onChange={handlePageChange
                              onChange={
                                totalEntries > itemsPerPage
                                  ? this.handlePageChange
                                  : null
                              }
                              itemClass="page-item"
                              linkClass={
                                totalEntries && totalEntries > 0
                                  ? "page-link"
                                  : "page-link disabled"
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.container-fluid */}
            </div>
            {/* End of Main Content */}
            {/* Footer */}
            <Footer />
            {/* End of Footer */}
          </div>
          {/* End of Content Wrapper */}
        </div>
        {/* End of Page Wrapper */}
        {/* Scroll to Top Button*/}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  question: state.question,
  alert: state.alert,
  loading: state.loading,
});

export default connect(mapStateToProps, {
  loadAllUsers,
  loadAllUsersForSearch,
  migrateQuestions,
  search,
  DownloadExcel,
})(AppDemo);
